var map = {
	"./cart.svg": "./platform/themes/martfury/assets/icons/cart.svg",
	"./search.svg": "./platform/themes/martfury/assets/icons/search.svg",
	"./user.svg": "./platform/themes/martfury/assets/icons/user.svg",
	"./wishlist.svg": "./platform/themes/martfury/assets/icons/wishlist.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./platform/themes/martfury/assets/icons sync \\.svg$";